import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { API_URL, isExpiredJWT } from "../utils";
import "../css/spinner.css";

function ViewPdf() {
  const { auth, refresh } = useContext(AuthContext);
  const { cmrId } = useParams();
  const [src, setSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function getTransport() {
      try {
        const res = await axios.get(API_URL + `/api/l/cmr/${cmrId}/view`, {
          headers: {
            Authorization: `Bearer ${auth.aT}`,
            "Content-Type": "application/pdf",
          },
        });
        setSrc(res.data.signedUrl);
      } catch (err) {
        console.error(err);
      }
    }

    if (auth.aT && !isExpiredJWT(auth.user.exp)) getTransport();
    else refresh();
  }, [auth, refresh, cmrId]);

  const handleLoad = () => setIsLoading(false);

  return (
    <div className="h-[75dvh]">
      <h1 className="text-2xl font-bold mb-2">Vizualizare CMR</h1>
      {isLoading && (
        <div className="spinner-container">
          <div className="spinner"></div>
          <span className=" ml-1">Loading PDF...</span>
        </div>
      )}
      {src && (
        <iframe
          title="pdf-view"
          style={{ width: "100%", height: "100%" }}
          src={src}
          onLoad={handleLoad}
        />
      )}
    </div>
  );
}

export default ViewPdf;
